import { wrapReducer } from "@client/content/lib/helper";
import {
  Actions as DetailActions,
  type LessonEventBeginActionData,
  type LessonEventSuccessActionData
} from "@client/content/modules/CourseDetail/actions";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type InitBeginActionData, type InitSuccessActionData } from "./actions";
import { type CourseProgress } from "./types";

const reducer = (state: CourseProgress.AppState = defaultState, action: ReduxAction<any>): CourseProgress.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      const { courseId } = action.data as InitBeginActionData;
      return {
        ...state,
        courseId,
        status: Status.Loading
      };
    }

    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }

    case Actions.InitSuccess: {
      const { completed, total } = action.data as InitSuccessActionData;
      return {
        ...state,
        completed,
        total,
        status: Status.Ready
      };
    }

    default:
      return state;
  }
};

export const defaultState: CourseProgress.AppState = {
  completed: 0,
  courseId: "",
  error: null,
  id: "",
  status: Status.None,
  total: 0
};
export const previewState: CourseProgress.AppState = {
  completed: 3,
  courseId: "",
  error: null,
  id: "",
  status: Status.Ready,
  total: 10
};
export default wrapReducer({
  defaultState,
  reducer,
  addon: (state: CourseProgress.AppState, action: ReduxAction<any>): CourseProgress.AppState => {
    switch (action.type) {
      case DetailActions.LessonEventSuccess: {
        // hook into ANY detail module to properly set progress
        const { courseId } = action.params as LessonEventBeginActionData;
        if (state.courseId === courseId) {
          const { lessons } = action.data as LessonEventSuccessActionData;
          return {
            ...state,
            completed: lessons.filter((y) => !y.isBonus && y.isComplete).length,
            total: lessons.filter((y) => !y.isBonus).length
          };
        }

        return state;
      }
      default:
        return state;
    }
  },
  previewState
});
